
<template>
  <!-- 私人地址下单页 -->
  <div style="background:#f5f5f5;height:170%">
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div style="margin-top:-28px;margin-bottom:-10px">
        <headerLocal :Vtext1="Vtext1" :Vtext2="Vtext2" ></headerLocal>
      </div>
      <div class="wrap_l">
        <el-collapse v-model="show1" class="leftItem Itemshow1">
          <el-collapse-item name="1">
            <template slot="title">
              <div
                style="
                  padding: 0 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="float: left; margin-right: 10px; margin-top: 6px">
                  <img src="../../assets/images/billdz.png" alt="地址" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >地址信息</div>
              </div>
            </template>
            <div class="semillWrap" style="padding: 0 30px;border-top:1px solid #ECECEC;">
              <div style="width: 100%; float: left;margin-bottom:10px">
                <div style="padding: 10px 0 0 25px; box-sizing: border-box">
                  <el-form
                    ref="fromText"
                    size="mini"
                    class="marginzero"
                    label-position="left"
                    label-width="100px"
                    :model="recAddressDTO"
                    :rules="checkform"
                  >
                    <!-- <el-form-item label="收货信息">
                      <div class="block">私人地址</div>
                    </el-form-item> -->
                    <el-form-item label="目的地" :required="true">
                      <!-- <el-select
                          style="width:260px"
                          v-model="toFABck"
                          value-key="id"
                          placeholder="请选择目的地"
                          clearable
                          @change="getGoodsTypeByCountryId(),getFBATrans(), getTimoney()"
                        >
                          <el-option v-for="item in podList"
                            :value="item"
                            :label="item.namec"
                            :key="item.id"
                          ></el-option>
                        </el-select> -->
                      <!-- <select-place-template3
                        v-if=""
                        style="height: 30px; line-height: 30px; font-size: 14px; border-radius: 10px;"
                        :tabHeadList="podTabHead"
                        :defaultTabValue="podDefaultTabValue"
                        :placeholder="podPlaceholder"
                        :selectAllButton="false"
                        @change="changePod"
                        v-model="toFABck"
                        :data="{ fba: podLetterGroup }"
                      ></select-place-template3> -->
                      <select-place-template3
                        ref="selectPlace3"
                        style="height: 30px; line-height: 30px; font-size: 14px; border-radius: 10px;"
                        :tabHeadList="podTabHead"
                        :defaultTabValue="podDefaultTabValue"
                        :placeholder="podPlaceholder"
                        :selectAllButton="false"
                        @change="changePod"
                        v-model="toFABck"
                        :data="podData"
                        :visible="privateAddressType == 1"
                      >
                        <template v-if="privateAddressType == 1" slot="content">
                          <search-wearhouse-page :value="toFABck" :baseData="podList" @change="changePod"></search-wearhouse-page>
                        </template>
                        <el-alert slot="footer" title="温馨提示：目前下拉只支持单选，装箱单处可以上传多个目的地。" type="warning" :closable="false"></el-alert>
                      </select-place-template3>
                      <template v-if="itemWrap && itemWrap.regionType === 5">
                        <el-button
                          @click="showZipCodeSearch"
                          :disabled="!(toFABck && toFABck.id)"
                          style="margin-left: 30px;"
                          type="primary"
                          plain
                        >查看分区邮编</el-button>
                      </template>
                    </el-form-item>
                    <el-row :gutter="0">
                      <el-col :span="10">
                        <el-form-item label="收货国家">
                          <el-input
                            v-model="recAddressDTO.recgoodscountry"
                            style="width: 260px"
                            disabled
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" class="TextCenter" style="margin-left:20px">
                        <el-form-item label="州" prop="recGoodsState">
                          <el-input
                            maxlength="30"
                            placeholder="请输入州"
                            v-model="recAddressDTO.recGoodsState"
                            style="width: 120px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" class="TextCenter" style="margin-left:-15px">
                        <el-form-item label="市" prop="recgoodscity">
                          <el-input
                            maxlength="30"
                            placeholder="请输入市"
                            v-model="recAddressDTO.recgoodscity"
                            style="width: 120px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0">
                      <el-col :span="12">
                        <el-form-item label="详细地址" prop="recwarehouseaddress">
                          <el-input
                            placeholder="请输入详细地址"
                            v-model="recAddressDTO.recwarehouseaddress"
                            style="width: 260px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" class="TextCenter">
                        <el-form-item label="邮政编码" prop="recGoodsPostcode">
                          <el-input
                            placeholder="请输入邮政编码"
                            :disabled="privateAddressType == 1"
                            v-model="recAddressDTO.recGoodsPostcode"
                            @change="getFBATrans"
                            style="width: 260px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系人" prop="recGoodsPerson">
                          <el-input
                            placeholder="请输入联系人"
                            v-model="recAddressDTO.recGoodsPerson"
                            style="width: 260px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" class="TextCenter">
                        <el-form-item label="联系电话" prop="recGoodsTel">
                          <el-input
                            placeholder="请输入联系电话"
                            v-model="recAddressDTO.recGoodsTel"
                            style="width: 260px"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item label="发货信息">
                      <div class="block">
                        <el-radio-group
                          class="Itemshow2"
                          @change="changeTi"
                          v-model="THFdata.checked"
                        >
                          <el-radio-button :label="true">上门取件</el-radio-button>
                          <el-radio-button :label="false">送货到仓</el-radio-button>
                        </el-radio-group>
                      </div>
                    </el-form-item>
                    <el-row style="float: left" :gutter="20">
                      <el-col :span="24" v-show="!THFdata.checked">
                        <el-form-item label="送仓日期" style="position: relative" :required="true">
                          <div class="block">
                            <el-date-picker
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              style="width: 260px"
                              v-model="inwarehousetime"
                              type="date"
                              placeholder="请选择送仓日期"
                              :picker-options="pickerOptions"
                            ></el-date-picker>
                          </div>
                          <span class="fontStyle" v-show="houseTime">请填写送仓日期</span>
                        </el-form-item>
                      </el-col>
                       <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item
                          label="仓库联系人"
                          style="position: relative"
                          :required="true"
                        >
                          <el-input
                            disabled
                            v-model="itemWrap.warehouseContactPerson"
                            style="width: 260px"
                            class="input-with-select"
                          >
                          </el-input>
                          <span class="fontStyle" v-show="contactPerson"
                            >请填写仓库联系人</span
                          >
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="提货地点" style="position: relative" :required="true">
                          <el-input
                            placeholder="请选择提货地址"
                            v-model="pickUparess"
                            style="width: 260px"
                            class="input-with-select"
                          >
                            <el-button
                              style="color: #FF4D01;background: #FFE3E6;"
                              @click="changeCheic()"
                              slot="append"
                            >联系簿</el-button>
                          </el-input>
                          <span class="fontStyle" v-show="countlistAddress">请填写提货地点</span>
                        </el-form-item>
                      </el-col>
                       <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item
                          label="仓库地址"
                          style="position: relative"
                          :required="true"
                        >
                          <el-popover
                            placement="top-start"
                            title="仓库地址"
                            trigger="hover"
                            :content="itemWrap.warehouseAddress"
                          >
                            <el-input
                              disabled
                              slot="reference"
                              v-model="itemWrap.warehouseAddress"
                              class="input-with-select"
                              style="width: 260px"
                            ></el-input>
                          </el-popover>
                          <span class="fontStyle" v-show="houseAddress"
                            >请填写仓库地址</span
                          >
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="提货日期" style="position: relative" :required="true">
                          <el-date-picker
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 260px"
                            v-model="todoorTime"
                            type="date"
                            placeholder="请选择提货日期"
                            :picker-options="pickerOptions"
                          ></el-date-picker>
                          <span class="fontStyle" v-show="thfPicker">请填写提货日期</span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="提货联系人" style="position: relative" :required="true">
                          <el-input
                            disabled
                            v-model="countLIst_T.name"
                            style="width: 260px"
                            class="input-with-select"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="THFdata.checked">
                        <el-form-item label="联系电话" style="position: relative" :required="true">
                          <el-input
                            disabled
                            style="width: 260px"
                            v-model="countLIst_T.tel"
                            class="input-with-select"
                          ></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item label="发货联系人" style="position: relative" :required="true">
                          <el-input
                            placeholder="请选择发货人"
                            v-model="countLIst_S.name"
                            style="width: 260px"
                            class="input-with-select"
                          >
                            <el-button
                              style="color: #FF4D01;background: #FFE3E6;"
                              @click="showdeliver()"
                              slot="append"
                            >联系簿</el-button>
                          </el-input>
                          <span class="fontStyle" v-show="countListName">请填写发货联系人</span>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-show="!THFdata.checked">
                        <el-form-item label="联系电话" style="position: relative" :required="true">
                          <el-input
                            disabled
                            style="width: 260px"
                            v-model="countLIst_S.tel"
                            class="input-with-select"
                          ></el-input>
                          <span class="fontStyle" v-show="countLisTtel">请填写联系电话</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div class="messageTag" v-if="(messageFlag || THFTipsFlag) && THFdata.checked">
                  <p>温馨提示：</p>
                  <p v-if="THFTipsFlag">
                    您已选择上门取件服务，您选择的提货地址为
                    <span>{{this.MessParvince}}{{this.MessCity}}</span>,已为您切换最新的价格信息，订单审核通过后，会尽快给您安排司机上门接收货物。
                  </p>
                  <!-- <p v-if="messageFlag">
                    您所填写的提货地址信息不在该产品收货范围内，确认下单后，将会收取提货费及其他相关费用。
                  </p> -->
                </div>
                <div class="messageTag" style="background: #fff; color: #666; border: 1px solid #FF4D01" v-if="storeHouseFlag">
                  <p>温馨提示：您已选择送货到仓服务，已为您切换最新的价格信息。</p>
                  <p>请将货物送至以下仓库：</p>
                  <p>
                    <span style="color:#FF4D01">仓库地址：</span>
                    <span>{{this.itemWrap.warehouseAddress}}</span>，联系人：
                    <span>{{this.itemWrap.warehouseContactPerson}}</span>，联系方式：
                    <span>{{this.itemWrap.warehouseContactTel}}</span>。
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <!-- <el-collapse v-model="showTH" class="leftItem show1" v-if="itemWrap.selfDelivery !== 2"> -->
        <el-collapse v-model="showTH" class="leftItem show1" v-if="itemWrap.deliveryType === 'ZT' || itemWrap.selfDelivery === 1">
          <el-collapse-item name="1">
            <template slot="title">
              <div
                style="
                  padding: 0 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="float: left; margin-right: 16px;margin-top: 6px; position: relative">
                  <img class="iconStyleTop" src="../../assets/imgs/TH.png" alt="地址" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    margin-left: 14px
                    color: black;
                  "
                >海外仓提货信息</div>
              </div>
            </template>
            <div class="semillWrap" style="padding: 0 40px; border-bottom: 1px solid #ececec">
              <div style="width: 100%; float: left; margin-bottom: 14px">
                <div style="padding: 8px 0 0 6px; box-sizing: border-box">
                  <el-form label-position="left" label-width="85px" :model="THFdata">
                    <el-form-item label="是否自提" style="margin-left: 12px; margin-bottom: 4px" v-if="itemWrap.selfDelivery !== 3">
                      <div
                        class="block"
                        style="
                          position: absolute;
                          left: -10px;
                          display: inline-block;
                          width: 200px;
                        "
                      >
                        <el-radio-group
                          v-model="isSelfDelivery"
                          class="show2"
                          size="small"
                          :disabled="itemWrap.deliveryType === 'ZT'"
                          @change="getFBATrans()"
                        >
                          <el-radio-button :label="true">是</el-radio-button>
                          <el-radio-button :label="false">否</el-radio-button>
                        </el-radio-group>
                      </div>
                    </el-form-item>
                    <el-form-item label="提货地址" style="margin-left: 12px; margin-bottom: 4px" v-if="isSelfDelivery">
                      <div
                        class="block"
                        style="
                          word-wrap: break-word;
                          font-family: Source Han Sans CN;
                          color: #333333;
                          font-weight: 500;
                        "
                      >
                          <p>
                            <span>{{ itemWrap.selfAddress }}</span>
                          </p>
                        </div>
                      </el-form-item>
                      <el-form-item label="联系方式" style="margin-left: 12px; margin-bottom: 4px">
                        <div
                          class="block"
                          style="
                            word-wrap: break-word;
                            font-family: Source Han Sans CN;
                            color: #333333;
                            font-weight: 500;
                          "
                        >
                          <p>
                            <span v-if="itemWrap.selfContacts">{{ itemWrap.selfContacts }}，</span>
                            <span v-if="itemWrap.selfTelephone">{{ itemWrap.selfTelephone }}</span>
                          </p>
                        </div>
                      </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="show2" class="leftItem Itemshow3">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="padding: 0 30px;position: relative">
                <div style="float: left; margin-right: 10px; margin-top: 6px">
                  <img src="../../assets/thicon.png" alt="货物" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >货物信息</div>
                <div class="packingbox">
                  <el-button
                    type="primary"
                    style="border-radius: 10px;width:120px"
                    @click.stop="excelVisibleBtn()"
                    :close-on-click-modal="false"
                  >上传装箱清单</el-button>
                  <el-button
                    class="DetailsBox"
                    v-if="ruleform.formLIst?ruleform.formLIst[0].weight:null"
                    size="medium"
                    type="text"
                    @click.stop="packingDetails"
                    :close-on-click-modal="false"
                  >查看装箱明细</el-button>
                </div>
              </div>
            </template>
            <div style="width: 100%; border-top:1px solid #ECECEC;">
              <div class="Item_list" style="padding-bottom: 0;border-bottom: 1px dashed #ECECEC;">
                <div class="tipRem">
                  <p>温馨提示：收费数量以仓库收货为准</p>
                </div>

                <el-form
                  ref="rulegoodsForm"
                  size="mini"
                  :model="ruleformPro"
                  class="marginzero"
                  label-position="left"
                  label-width="100px"
                >
                  <el-row :gutter="20" v-for="(item, index) of ruleformPro.list" :key="index" style="margin-top: 15px">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item
                          label="重量"
                          :prop="'list.'+index+'.weight'"
                          :rules="{
                            required: true,
                            message: '请输入重量',
                            trigger: 'blur'
                          }"
                        >
                          <el-input
                            style="width:260px"
                            @keyup.native="inputNum($event)"
                            v-model="item.weight"
                            @change="getFBATrans(), getTimoney()"
                          >
                            <span class="cmb-box" type="text" slot="suffix">(KG)</span>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="体积"
                          :prop="'list.'+index+'.cbm'"
                          :rules="{
                            required: true,
                            message: '请输入体积',
                            trigger: 'blur'
                          }"
                        >
                          <el-input
                            style="width:260px"
                            @keyup.native="inputNumCbm($event)"
                            v-model="item.cbm"
                            @change="getFBATrans(), getTimoney()"
                          >
                            <span class="cmb-box" type="text" slot="suffix">(CBM)</span>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12" style="margin-top: 6px;">
                        <el-form-item
                          label="箱数"
                          :prop="'list.'+index+'.boxNum'"
                          :rules="{
                            required: true,
                            message: '请输入箱数',
                            trigger: 'blur'
                          }"
                        >
                          <el-input
                            style="width:260px"
                            v-model="item.boxNum"
                            @keyup.native="number($event)"
                            @change="getFBATrans(), getTimoney()"
                          >
                            <span class="cmb-box" type="text" slot="suffix">(箱)</span>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" style="margin-top: 6px;">
                        <el-form-item
                          label="货物类型"
                          :prop="'list.'+index+'.goodstypeid'"
                          :rules="{
                            required: true,
                            message: '请选择货物类型',
                            trigger: 'change'
                          }"
                        >
                          <el-select
                            style="width:260px"
                            v-model="item.goodstypeid"
                            :placeholder="toFABck.id || toFABck.id === 0 ? '请选择' : '请先选择目的地'"
                            @change="(val) => {
                              setGoodType(val, index)
                              getFBATrans()
                              getTimoney()
                            }"
                          >
                            <el-option
                              v-for="item in goodsTypeList"
                              :value="item.goodsTypeId"
                              :label="item.goodsTypeName"
                              :key="item.goodsTypeId"
                            ></el-option>
                          </el-select>
                          <el-button
                            style="margin-top: 2px;margin-left: 9px;"
                            v-if="ruleformPro.list.length != 1"
                            type="text"
                            class="deleteBox"
                            @click="handleDel(index)"
                          >
                            <i style="font-weight: 600; font-size: 16px" class="el-icon-delete"></i>&nbsp;
                          </el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-button
                      size="mini"
                      type="text"
                      style="
                        border-radius: 2px;
                        color: #FF4D01;
                        margin-left: 10px;
                        margin-bottom: 10px;
                        font-size: 14px;
                      "
                      @click="handleAdd(index)"
                      v-if="ruleformPro.list.length == index + 1"
                    >
                      <i
                        class="el-icon-circle-plus-outline"
                        style="font-weight: 600; font-size: 16px"
                      ></i>&nbsp;添加PRO号
                    </el-button>
                  </el-row>
                </el-form>
              </div>
              <!-- <div class="tipRem">温馨提示：收费数量以仓库收货为准</div> -->
            </div>

            <div class="numBox">
                <div style="float: left; margin-top: 10px">
                  <span>总箱数：</span>
                  <span style="margin-left: 4px">{{ getNumBox }}</span>箱
                </div>
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                  ref="refFormInline"
                  :rules="rulesFormInline"
                  label-width="120px"
                >
                  <el-form-item prop="sumWeight" label="总重量" style="margin-bottom: 0;">
                    <el-input
                      @keyup.native="inputNum($event)"
                      style="width: 200px"
                      disabled
                      v-model="formInline.sumWeight"
                      placeholder="请输入总重量"
                      @input="validataCode"
                      @change="getTimoney(), getFBATrans()"
                    >
                      <span type="text" slot="suffix">(KG)</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item style="margin-left: 30px;margin-bottom: 0;" prop="sumCbm" label="总体积">
                    <el-input
                      @keyup.native="inputNumCbm($event)"
                      style="width: 200px"
                      disabled
                      @change="getTimoney(), getFBATrans()"
                      v-model="formInline.sumCbm"
                      placeholder="请输入总体积"
                      @input="validataCodeCmb"
                    >
                      <span type="text" slot="suffix">(CBM)</span>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
          </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="show3" class="leftItem">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="padding: 0 30px">
                <div style="float: left; margin-right: 10px; margin-top: 6px">
                  <img src="../../assets/style.png" alt="增值服务" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >贸易信息</div>
              </div>
            </template>
            <div class="Item_list" style="border-top:1px solid #ECECEC;">
              <div class="info_list">
                <el-checkbox v-model="isCheckedDeclare">买单报关(不能提供申报资料)</el-checkbox>
                <br />
                <el-checkbox v-model="ischecked" @change="Changehandle">退税报关(能提供申报资料)</el-checkbox>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        <!-- 补充信息 -->
        <el-collapse v-model="show4" class="leftItem">
          <el-collapse-item name="1">
            <template slot="title">
              <div style="padding: 0 30px">
                <div style="float: left; margin-right: 10px; margin-top: 6px">
                  <img src="../../assets/bcinfo.png" alt="补充信息" />
                </div>
                <div
                  style="
                    float: left;
                    font-size: 18px;
                    font-weight: bold;
                    color: black;
                  "
                >补充信息</div>
              </div>
            </template>
            <div class="Item_list" style="border-top:1px solid #ECECEC; padding:20px 0 10px 60px">
              <el-form
                label-position="left"
                class="demo-dynamic"
                size="mini"
                :model="ruleformAdd"
                :rules="ruleformAddRules"
                ref="ruleformAdd"
                :show-message="true"
              >
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item class="rules" label-width="95px" label="客户订单" prop="fbxBoxNum">
                      <el-input
                        style="width:260px"
                        type="text"
                        v-model="ruleformAdd.fbxBoxNum"
                        size="mini"
                        placeholder="请输入客户订单编号"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label-width="84px" class="rules" label="备注" prop="FBAremarks">
                      <el-input
                        style="width:260px"
                        size="mini"
                        v-model="ruleformAdd.FBAremarks"
                        placeholder="请输入备注"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="12">
                    <el-form-item
                      label-width="95px"
                      class="rules"
                      label="上传附件"
                    >
                      <el-upload
                        ref="uploadexl"
                        style="text-align: center"
                        :show-file-list="true"
                        :http-request="uploadSectionFile"
                        :file-list="uploadData.fileList"
                        :on-remove="removefileList"
                        class="upload-demo"
                        drag
                        action=""
                        multiple
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          将文件拖到此处，或<em>点击上传</em>
                        </div>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label-width="50px" class="rules">
                      <p style="padding: 22px">
                        温馨提示：上传装箱单、发票、营业执照、身份证等信息
                        可提升订单响应效率。
                      </p>
                    </el-form-item>
                  </el-col>-->
                </el-row>
              </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 物流产品信息 -->
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #341418;
          "
        >物流产品信息</p>
        <div
          class="Item_Right animate__animated animate__bounceInRight"
          style="border-top:1px solid #ECECEC;margin-top:22px"
        >
          <div class="header_text">
            <p class="coutText">
              <span class="littit">物流产品</span>
              <!-- {{ itemWrap.containsTheTariffs ? "包税" : "不包税" }} -->
              <span class="fontString">{{ itemWrap.productName}}</span>
            </p>
            <p class="coutText">
              <span class="littit">整体时效</span>
              <span class="fontString">{{ itemWrap.aging || '/' }}</span>
            </p>
            <p class="coutText" v-show="itemWrap.volumeWeightRatio">
              <span class="littit">
                体积重比率
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top-start"
                  style="margin-right: 10px;"
                >
                  <div slot="content" style="max-width:220px">
                    <span>体积重比率用于计算体积重，体积重=长*宽*高/体积重比率</span>
                    <br />
                    <span>例如:100CM*100CM*100CM规格的箱子，若体积重比率=6000，则体积重=100*100*100/6000 ≈ 167KG</span>
                  </div>
                  <span style="font-size: 14px; color: rgb(230, 162, 60)" class="el-icon-question"></span>
                </el-tooltip>
              </span>
              <span class="fontString">{{ itemWrap.volumeWeightRatio || '/' }}</span>
            </p>
            <p class="coutText" v-show="itemWrap.weightVolumeRatioDesc">
              <span class="littit">重量转换</span>
              <span class="fontString">{{ itemWrap.weightVolumeRatioDesc || '/' }}</span>
            </p>
            <p class="coutText">
              <span class="littit">可接货物类型：</span>
              <span class="fontString">{{ itemWrap.goodsTypeNames || '/' }}</span>
            </p>
          </div>
          <el-divider></el-divider>
          <div class="header_text">
            <p class="coutText">
              <span class="littit">总箱数</span>
              <span class="fontString">{{ goodsForm.preBoxNum }}(箱)</span>
            </p>
            <p class="coutText">
              <span class="littit">总体积</span>
              <span class="fontString">{{ goodsForm.preAllCbm }}(CBM)</span>
            </p>
            <p class="coutText">
              <span class="littit">总重量</span>
              <span class="fontString">{{ goodsForm.preAllWeight }}(KG)</span>
            </p>
            <p class="coutText">
              <span class="littit">计费重</span>
              <span class="fontString">{{ FBATransmoney.chargeWeight || '/' }}</span>
            </p>
          </div>
        </div>

        <div class="Item_Right" v-if="FBATransmoney.surchargeDTOS">
          <!-- productFeeList -->
          <p class="costBox" v-for="(item, index) in productFeeList" :key="index">
            <span class="littit detailed" style="width: 30%">{{ item.label }}</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
              style="margin-right: 10px;cursor: pointer;"
            >
              <div slot="content" style="max-width: 220px">
                <span>{{item.changeInfo}}</span>
              </div>
              <i
                style="color:#e6a23c;vertical-align: middle;margin-left: 8px;margin-bottom: 4px;font-size:16px"
                class="el-icon-question"
              ></i>
            </el-tooltip>
            <span class="detailed descbox" style="font-weight: bold">
              {{ item.value }}
            </span>
          </p>
        </div>
        <div
          class="Item_Right"
          v-if="FBATransmoney.goodsTypeFeeDTOS.length>0||(calFBAFeeIDTOS.feeDTOList.length>0&&ischecked)"
        >
          <p class="costBox" v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS" :key="index">
            <span class="littit detailed" style="width: 30%">{{ item.goodsTypeName }}</span>
            <span v-if="item.isNeedInquiry">
              当前线路为单询，需线下确认费用。
            </span>
            <span class="detailed descbox" style="font-weight: bold" v-else>
              {{ item.currency }}{{ item.amount }}
              <span
                style="font-size: 12px; font-weight: 100"
              >({{ item.calDesc }})</span>
            </span>
          </p>
          <p
            v-show="THFdata.checked && THFdata.amount"
            class="costBox animate__animated animate__bounceInRight"
          >
            <span class="littit detailed" style="width: 30%">提货费</span>
            <span class="detailed descbox" style="font-weight: bold">
              {{ THFdata.currency }} {{ THFdata.amount }}
              <span
                class="detailed"
                style="font-size: 12px; font-weight: 100"
              >({{ THFdata.calDesc }})</span>
            </span>
          </p>
          <div v-if="ischecked == true">
            <div
              class="costBox animate__animated animate__bounceInRight"
              v-for="(item, index) in calFBAFeeIDTOS.feeDTOList"
              :key="index"
            >
              <p>
                <span class="littit detailed" style="width: 30%">{{ item.feeName }}</span>
                <span class="detailed descbox" style="font-weight: bold">
                  {{ item.currency }} {{ item.amount }}
                  <span
                    class="detailed"
                    style="font-size: 12px; font-weight: 100"
                  >({{ item.calDesc }})</span>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="Item_Right">
          <div class="coutText" v-if="couponList.length > 0">
            <span class="littit">平台优惠券</span>
            <span
              class="fontString"
              @click="dialogCoupon = true"
              style="cursor: pointer; color: #FF4D01"
            >
              <img
                :src="ossPath + '/pages/home/coupon/icon_coupon.png'"
                alt=""
                class="img"
                style="margin: 0 5px"
              />
              {{ couponList.length }}张优惠券可用<i
                class="el-icon-arrow-right"
                style="margin-left: 5px"
              ></i>
            </span>
          </div>
          <div class="coutText" v-else>
            <span class="littit">平台优惠券</span>
            <span
              class="fontString"
              style="color: #FF4D01"
            >
              <img
                :src="ossPath + '/pages/home/coupon/icon_coupon.png'"
                alt=""
                class="img"
                style="margin: 0 5px"
              />
              暂无可用优惠券
            </span>
          </div>
          <template v-if="couponFilterCount > 0">
            <p class="coutText">
              <span class="littit">原价</span>
              <span
                style="float: right;"
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span style="font-size:14px;color: #333;font-weight: bold">
                  <span v-show="item.currency != ''">
                    {{
                    item.currency
                    }}
                  </span>
                  <span v-show="item.amount > 0">{{ item.amount }}</span>
                </span>
              </span>
            </p>
            <p style="font-size:14px;color:#FFBF4D;line-height:28px">
              <i style="font-style: normal">(实际费用以入仓信息为准)</i>
            </p>
            <div class="coutText" v-if="couponFilterCount > 0">
              <span class="littit">已优惠</span>
              <span class="fontString" style="color: #FF4D01">
                CNY -{{ couponFilterCount }}
              </span>
            </div>
            <div class="coutText">
              <span class="littit">合计</span>
              <span
                class="fontString"
                style="font-size:18px;color: #FF4D01;font-weight: bold"
              >CNY {{ resultPrice.toFixed(2) }}</span>
            </div>
          </template>
          <template v-else>
            <p class="coutText">
              <span class="littit">预估费用</span>
              <span
                style="float: right;"
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span style="font-size:14px;color: #333;font-weight: bold">
                  <span v-show="item.currency != ''">
                    {{
                    item.currency
                    }}
                  </span>
                  <span v-show="item.amount > 0">{{ item.amount }}</span>
                </span>
                <!-- <span v-show="item.currency != ''">+</span> -->
              </span>
            </p>
            <p style="font-size:14px;color:#FFBF4D;line-height:28px">
              <i style="font-style: normal">(实际费用以入仓信息为准)</i>
            </p>
            <p class="coutText">
              <span class="fontString littit" style="font-size:14px;color: #999">折合人民币</span>
              <span
                class="fontString"
                style="font-size:18px;color: #FF4D01;font-weight: bold"
              >CNY {{ calculatePrice }}</span>
            </p>
          </template>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%;color:#F56C6C">{{errormessage}}</div>
          <div style="width: 100%;">
            <el-button
              class="Itemshow4"
              style="width: 100%; height:50px; border-radius: 10px; background: #FF4D01; color: #ffffff; font-size:18px ;font-weight: bold"
              @click="submitForm()"
            >提交订单</el-button>
          </div>
          <div style="text-align: center; margin-top: 23px;display: flex;align-items: baseline;">
            <el-checkbox style="float: left;font-size:12px" v-model="checkvalue">我已阅读并同意</el-checkbox>
            <span
              :style="{ color: value ? '#FFBF4D' : '#FF4D01' }"
              style="cursor: pointer;font-size:12px;"
              @click="registerPolicyDialog = true"
              data-v-9aa3ee46
            >《货物承运电子协议》</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 -->
    <takeBill
      :showMydialog="showMydialog"
      :cityWhiteList="cityWhiteList"
      @getTimoney="getTimoney"
      @closeExtractlog="closeExtractlog"
    ></takeBill>
    <!-- 发货人 -->
    <deliverGoods
      :deliverShow="deliverShow"
      @closeaddPopmo="closeaddPopmo"
      @closeDeliver="closeDeliver"
      @setDeliver="setDeliver"
    ></deliverGoods>

    <!-- Excel上传 -->
    <el-dialog
      title="文件上传"
      :visible.sync="excelVisible"
      width="40%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="helper">下载产品装箱单模板，并填写后上传</div>

      <div
        v-if="elTag == true && this.fileName != ''"
        center
        style="text-align: center; margin: 30px 0"
      >
        <div class="tagBox" @close="handleClose()">{{ fileName }}</div>
        <span
          v-if="isReupdateFile"
          @click="reUpdateFile"
          style="color: #FF4D01; cursor: pointer"
        >重新上传</span>
      </div>
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFileList"
        class="upload-demo"
        drag
        action
        multiple
        v-if="excelVisibleSync"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">仅限xls文件</div>
      </el-upload>

      <div v-show="progressFlag" style="margin:20px 0">
        <el-progress
          status="success"
          :text-inside="true"
          :stroke-width="14"
          :percentage="progressPercent"
        ></el-progress>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="success" @click="Getdown()">下载模板</el-button>

        <el-button style="margin-right: 20px;" size="mini" @click="excelVisiblefalse">取 消</el-button>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%;margin-top:20px"
        >
          <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
          <el-table-column align="center" width="80" prop="order" label="错误行"></el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- 显示装箱明细 -->
    <el-dialog
      title="装箱明细"
      :visible.sync="googDetail"
      width="850px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table :data="tableDataDetail" border>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column property="fbxBoxNo" label="客户箱号" width="186">
          <template slot-scope="scope">{{ scope.row.fbxBoxNo || "-" }}</template>
        </el-table-column>
        <el-table-column property="poTrackingNo" label="货物追踪号" width="120">
          <template slot-scope="scope">{{ scope.row.poTrackingNo || "-" }}</template>
        </el-table-column>
        <el-table-column property="length" label="L(cm)">
          <template slot-scope="scope">{{ scope.row.length || "-" }}</template>
        </el-table-column>
        <el-table-column property="width" label="W(cm)">
          <template slot-scope="scope">{{ scope.row.width || "-" }}</template>
        </el-table-column>
        <el-table-column property="height" label="H(cm)">
          <template slot-scope="scope">{{ scope.row.height || "-" }}</template>
        </el-table-column>
        <el-table-column property="weight" label="WEIGHT(kgs)实重">
          <template slot-scope="scope">{{ scope.row.weight || "-" }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="getBoxDetail(scope.row.goodsDTOList, scope.row)"
              type="text"
              size="small"
            >查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <p v-if="isGetMDate" style="text-align: center; line-height: 50px">
        <span>剩余{{ moreNum }}项未展示,</span>
        <a href="javascript:;" @click="getMData()">点击加载更多</a>
      </p>

      <div class="googDetailBox">
        <span
          style="float: right; margin-top: 10px; margin-right: 30px"
        >货物总箱量: {{ this.ruleform.formLIst?this.ruleform.formLIst.length:'' }}箱</span>
      </div>

      <div class="KnowBox">
        <el-button
          style="width: 20%; background: #FF4D01; color: #ffffff"
          @click="googDetail = false"
        >我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 查看箱子详情弹窗 -->
    <el-dialog
      center
      class="jackRadius"
      :visible.sync="showGoodsList"
      title="商品详情"
      width="80%"
      :before-close="handleCloseDetails"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-table
          border
          size="mini"
          :data="goodsDetailList"
          tooltip-effect="dark"
          :header-cell-style="{ background: 'rgb(95 74 255 / 23%)' }"
          ref
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="中文品名">
            <template slot-scope="scope">{{ scope.row.namec || "-" }}</template>
          </el-table-column>
          <el-table-column label="英文品名">
            <template slot-scope="scope">{{ scope.row.namee || "-" }}</template>
          </el-table-column>
          <el-table-column label="商品类型">
            <template slot-scope="scope">{{ scope.row.goodstype || "-" }}</template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">{{ scope.row.num || "-" }}</template>
          </el-table-column>
          <el-table-column label="型号">
            <template slot-scope="scope">{{ scope.row.model || "-" }}</template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">{{ scope.row.brand || "-" }}</template>
          </el-table-column>

          <el-table-column label="货值">
            <template slot-scope="scope">{{ scope.row.declaredValue || "-" }}</template>
          </el-table-column>

          <el-table-column label="海关编码">
            <template slot-scope="scope">{{ scope.row.hsCode || "-" }}</template>
          </el-table-column>

          <el-table-column label="材质">
            <template slot-scope="scope">{{ scope.row.materialc || "-" }}</template>
          </el-table-column>

          <el-table-column prop="pcs" label="用途">
            <template slot-scope="scope">{{ scope.row.purposec || "-" }}</template>
          </el-table-column>

          <el-table-column prop="pcs" label="是否带电">
            <template slot-scope="scope">
              {{
              scope.row.isHasBattery === true
              ? "是"
              : scope.row.isHasBattery === false
              ? "否"
              : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="是否带磁">
            <template slot-scope="scope">
              {{
              scope.row.isHasMagnetic === true
              ? "是"
              : scope.row.isHasMagnetic === false
              ? "否"
              : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="是否粉末/液体">
            <template slot-scope="scope">
              {{
              scope.row.isPowderLiquid === true
              ? "是"
              : scope.row.isPowderLiquid === false
              ? "否"
              : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="图片">
            <template slot-scope="scope">
              <img style="width: 50px; height: 50px" :src="scope.row.picUrl" alt="图片" />
            </template>
          </el-table-column>
          <el-table-column prop="pcs" label="销售链接">
            <template slot-scope="scope">
              <a
                v-if="scope.row.salesUrl"
                :href="scope.row.salesUrl"
                target="_blank"
              >{{ scope.row.salesUrl }}</a>
              <template v-else>-</template>
            </template>
          </el-table-column>
        </el-table>
        <p v-if="isDetailList" style="text-align: center; line-height: 50px">
          <span>剩余{{ moreNumber }}项未展示,</span>
          <a href="javascript:;" @click="DetailListMate()">点击加载更多</a>
        </p>
      </div>
    </el-dialog>
    <!-- 运输协议 -->
    <el-dialog title="货物承运电子协议" center :visible.sync="registerPolicyDialog" width="50%">
      <textInfo></textInfo>
    </el-dialog>

    <div class="open-by-check">
      <el-dialog
        title="提示"
        :visible.sync="checkVisible"
        width="432px"
        class="open-by-check"
        :show-close="false"
        :close-on-click-modal="false"
        @close="checkVisible = false">
        <!-- <p>您还不能下单，请先完成以下流程：</p>
        <span>{{tips}}</span> -->
        <div slot="title"
          class="header-row">
          <div class="title">提示</div>
        </div>
        <template v-if="Authorization.authenticationInfoDTO.state === 3 && Authorization.authenticationInfoDTO.type === 2">
          <div class="hint">分销大使暂不支持下单，如有需要请联系客服</div>
          <span slot="footer" class="footer-row">
            <el-button type="primary" class="btn-confirm" @click="$router.go(-1)">取消</el-button>
          </span>
        </template>
        <template v-else-if="Authorization.authenticationInfoDTO.state === 3 && Authorization.authenticationInfoDTO.type === 3">
          <div class="hint">省代暂不支持下单，如有需要请联系客服</div>
          <span slot="footer" class="footer-row">
            <el-button type="primary" class="btn-confirm" @click="$router.go(-1)">取消</el-button>
          </span>
        </template>
        <template v-else>
          <div class="hint">您还不能下单，请先完成以下流程：</div>
          <div class="step-row"  v-if="Authorization.authenticationInfoDTO.state === -1 || Authorization.authenticationInfoDTO.state === 2">
            实名认证
          </div>
          <div class="step-row"  v-else-if="Authorization.authenticationInfoDTO.state === 1">
            实名认证审核 （<span style="color: #FF4D01">实名认证审核中，请耐心等待。如有疑问请联系平台客服</span>）
          </div>
          <span slot="footer" class="footer-row">
            <el-button type="primary" class="btn-confirm" @click="$router.go(-1)">取消</el-button>
            <el-button type="primary" v-if="Authorization.authenticationInfoDTO.state === -1 || Authorization.authenticationInfoDTO.state === 2" class="btn-confirm" @click="enterForAuth">去认证</el-button>
          </span>
        </template>
      </el-dialog>
    </div>

    <zip-code-region-search
      :visible.sync="visibleZipCode"
      :list="zipCodeRegionList"
    />
    <!-- 优惠券 -->
    <select-coupon-list
      :visible.sync="dialogCoupon"
      :list="couponList || []"
      :default-select="selectCouponList"
      :orderAmount="Number(calculatePrice)"
      @change="changeSelectCoupon"
    ></select-coupon-list>
  </div>
</template>

<script>
import headerLocal from "../placeOrder/placeindexInfo/header_local.vue"
import qs from "qs"
import Driver from "driver.js"
import { GoodsformCheck } from "./fromCheck.js" //商品表单校验
import takeBill from "./components/takeBill.vue" //提货联系人
import deliverGoods from "./components/deliverGoods.vue" //发货联系人
import textInfo from "../NewOrder/textInfo.vue"
import { mapState } from "vuex"
import {isArray, isObject, debounce} from "my-tools-kit";
import ZipCodeRegionSearch from "@/components/placeOrder/components/zipCodeRegionSearch";
import selectPlaceTemplate3 from "../../../common/newSelectPlace/selectPlaceTemplate3"
import searchWearhousePage from './components/searchWearhousePage'
import { makePy } from '@common/pinyin'
import {sendCustomerOperationRecord} from "@/assets/js/utils";
import selectCouponList from "@common/selectCoupon/selectCouponList.vue"

export default {
  mixins: [GoodsformCheck],
  components: {
    ZipCodeRegionSearch,
    takeBill,
    deliverGoods,
    textInfo,
    headerLocal,
    selectPlaceTemplate3,
    searchWearhousePage,
    selectCouponList
  },
  data () {
    var validateCode = (rule, value, callback) => {
      var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/
      if (value.length > 15 || value.length < 1) {
        callback(new Error("总重量请输入0到99999范围内的数,允许输入小数点后三位"))
      }
      if (value <= 0) {
        callback(new Error("总重量必须大于0,请检查"))
      }
      var re = /^[0-9]+.?[0-9]*/ //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (!re.test(value)) {
        callback(new Error("请输入数字"))
      }
      if (!reg.test(value)) {
        callback(new Error("总重量必须大于0,请检查"))
      } else {
        callback()
      }
    }
    var validateTiCode = (rule, value, callback) => {
      var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/
      if (value.length > 15 || value.length < 1) {
        callback(new Error("总体积请输入0到99999范围内的数,允许输入小数点后三位"))
      }
      if (value <= 0) {
        callback(new Error("总体积必须大于0,请检查"))
      }
      var re = /^[0-9]+.?[0-9]*/ //判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
      if (!re.test(value)) {
        callback(new Error("请输入数字"))
      }
      if (!reg.test(value)) {
        callback(new Error("总体积必须大于0,请检查"))
      } else {
        callback()
      }
    }
    return {
      couponFilterCount: 0, // 预计优惠金额
      couponList: [], // 优惠券列表
      dialogCoupon: false,
      selectCouponList: [],
      orderAmount: 0,
      countCouponBeforeParams: {
        type: 2,
      },
      endWarehouseVisiblePopover: false,
      podTabHead: [
        { label:"非FBA仓库", value:"noFba", listLevel:1, openSelectAll:false }
      ],
      podDefaultTabValue: 'noFba',
      podPlaceholder: '请选择目的地',
      checkVisible: false,
      Vtext1: "专线大厅",
      Vtext2: "下单信息填写",
      // Vtext3: "下单信息填写",
      checkvalue: false,
      registerPolicyDialog: false,
      errormessage: '',
      driver: null, // 引导
      formUpdata: new FormData(),
      successUpload: [],
      uploadData: {
        fileList: [],
        fileName: [],
      },
      goodsForm: {
        preAllCbm: "",
        preAllWeight: "",
        preBoxNum: "",
      },
      recAddressDTO: {
        recGoodsPerson: "",
        recGoodsPostcode: "",
        recGoodsState: "",
        recGoodsTel: "",
        recgoodscity: "",
        recgoodscountry: JSON.parse(sessionStorage.getItem("itemWrap"))
          .toCountryName,
        recremarks: "",
        recwarehouseaddress: "",
      },
      pickUparess: "",
      goodsList: [],
      // 新增FBA编号
      sumBoxNumber: "",
      sumWeight: "",
      sunCmb: "",
      // fbxBoxNum: "",
      // FBAremarks: "",
      ruleformAdd: {
        fbxBoxNum: "",
        FBAremarks: "",
      },
      ruleformAddRules: {
        fbxBoxNum: [
          { required: false, message: "客户订单号最多只能输入30位" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 30) {
                callback(new Error("客户订单号最多只能输入30位"))
              } else {
                callback()
              }
            },
            trigger: "blur",
          },
        ],
        FBAremarks: [
          { required: false, message: "备注最多只能输入50位" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 50) {
                callback(new Error("备注最多只能输入50位"))
              } else {
                callback()
              }
            },
            trigger: "blur",
          },
        ],
      },
      fileUrl: "",
      fileSize: "",
      isReupdateFileTrue: false,
      isGetMDate: true,

      // itemWrap: this.$route.query.itemWrap,
      itemWrap: JSON.parse(sessionStorage.getItem("itemWrap")),
      width: "420px",
      itemid: "",
      countLIst_S: {
        //发货
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      deliverShow: false,
      formData: {
        //增值服务展示
        totalExpense: "",
        amount: 0,
        feeItemDTOS: [],
      },
      ischecked: false,
      calFBAFeeIDTOS: {
        //增值服务计算
        amount: 0,
        feeDTOList: [],
      },
      inwarehousetime: "", //送仓时间
      show1: ["1"],
      show2: ["1"],
      show3: ["1"],
      show4: ["1"],
      showTH: ["1"],
      billType: null,
      imageNum: 1,
      errorLabel: [],
      upUrl: "",
      transportTypeCode: null,
      goodsTypeShow: false,
      props: {
        value: "namec",
        label: "namec",
      },
      value: [],
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      showMydialog: false,
      nameOrPhone: "",
      tableData: [],
      tempTableData: [],
      goodslisttotal: 0,
      goodstypelist: [],
      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      auto_fixed: false,
      cbm: null,
      tableData: [],
      fromCityid: sessionStorage.getItem("fromCityid"),
      toFABck: sessionStorage.getItem("toFABck") && JSON.parse(sessionStorage.getItem("toFABck")).id
        ? JSON.parse(sessionStorage.getItem("toFABck"))
        : {},
      FBATransmoney: {
        //运输费
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
        chargeWeight: "",
      },
      newTihuoarr: "", //需展示的提货地址
      todoorTime: null,
      THFdata: {
        checked: true,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: "",
        maxKilometer: "",
        calDesc: "",
      },
      pageNum: 1,
      ruleform: {
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            goodsDTOList: [],
          },
        ],
      },
      clickPsitem: {}, //当前点击收货地址item
      addgoodform: {
        id: "",
        brand: "",
        customerid: "",
        declaredValue: "",
        goodstypeid: "",
        hsCode: "",
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        model: "",
        salesUrl: "",
        isHasBattery: false,
        isPowderLiquid: false,
        isHasMagnetic: false,
        picUrl: "",
      },
      thatGoodslist: [],
      activeLIst: [],
      urbanAreas: [],
      imageUrl: "",
      goodsDetailList: [],
      isDetailList: true,
      moreNum: null,
      moreNumber: null,
      isFastOrder: false,
      // 手动条件判断
      houseTime: false,
      countLisTtel: false,
      contactPerson: false,
      countlistAddress: false,
      houseAddress: false,
      thfPicker: false,
      countListName: false,
      isCheckedDeclare: true,
      excelVisible: false,
      elTag: false,
      fileName: "",
      isReupdateFile: false,
      excelVisibleSync: false,
      tableDataDetail: [],
      showGoodsList: false,
      googDetail: false,
      privateOrderBoxAttachmentDTO: {
        fileName: '',
        fileSize: '',
        fileUrl: ''
      },
      progressPercent: 0,
      progressFlag: false,
      messageFlag: false,
      MessParvince: "",
      MessCity: "",
      storeHouseFlag: false,
      productFeeList: [],
      goodsTypeList: [],
      THFTipsFlag: false,
      ruleformPro: {
        list: [
          {
            weight: "",
            cbm: "",
            boxNum: "",
            goodstypeid: ""
          },
        ],
      },
      isSelfDelivery: false,
      formInline: {
        sumCbm: "",
        sumWeight: "",
      },
      rulesFormInline: {
        sumWeight: [
          { required: true, message: "请输入总重量", trigger: "change" },
          { required: true, validator: validateCode, trigger: "change" },
        ],
        sunCmb: [
          { required: true, message: "请输入总体积", trigger: "change" },
          { required: true, validator: validateTiCode, trigger: "change" },
        ],
      },
      podList: [],
      // 邮编分区搜索弹窗显示状态
      visibleZipCode:false,
      zipCodeRegionList:[],
      podData: {
        noFba: [],
        privateCity: [],
        zipCode: []
      },
      privateAddressType: null
    }
  },
  watch: {
    todoorTime (old, neval) {
      if (old != "" || old != null) {
        this.thfPicker = false
      } else {
        this.thfPicker = true
      }
    },
    inwarehousetime (old, newval) {
      if (old != "" || old != null) {
        this.houseTime = false
      } else {
        this.houseTime = true
      }
    },
    isCheckedDeclare (old, newval) {
      // console.log("买单", old);
      if (old == true) {
        this.ischecked = false
      }

      if (old == false && this.ischecked == false) {
        this.isCheckedDeclare = true
      }
    },
    ischecked (old, isnew) {
      // console.log("退税", old);
      if (old == true) {
        this.isCheckedDeclare = false
      }

      if (old == false && this.isCheckedDeclare == false) {
        this.isCheckedDeclare = true
      }
    },
  },
  computed: {
    ...mapState(["Authorization"]),
    calculatePrice () {
      //计算总费用
      let Totalmoney = 0 //总费用
      let FBATransmoney = 0 //运输费
      let THFmoney = 0 //提货费
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0
      }
      Totalmoney = FBATransmoney + THFmoney + this.calFBAFeeIDTOS.amount
      return Totalmoney.toFixed(2)
    },
    resultPrice() {
      let price = this.calculatePrice
      if (this.couponFilterCount) {
        price = this.calculatePrice - this.couponFilterCount
      }
      return price
    },
    newArray () {
      //监听 币种
      let totalFeiyong = [] //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))) //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))) //提货费费币种
      }
      this.calFBAFeeIDTOS.feeDTOList.forEach((item) => {
        totalFeiyong.push(JSON.parse(JSON.stringify(item)))
      })
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency
        })
        hasValue === -1 && total.push(cur)
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ))
        return total
      }, [])
      return newArray
    },
    // 计算箱子总数量
    getNumBox () {
      let arr = 0
      this.ruleformPro.list.map((item, index) => {
        arr += Number(item.boxNum)
      })
      return arr
    }
  },
  methods: {
    getCouponListData() {
      // /api/bns/findAvailableCoupon
      this.selectCouponList = []
      this.couponFilterCount = 0
      this.axios.get(`/bns/findAvailableCoupon?amount=${this.FBATransmoney.amount}`)
      .then(res => {
        if(res.data.code === 200) {
          this.couponList = res.data.datas
        } else this.couponList = []
      })
    },
    // 计算价格
    changeSelectCoupon(list = []) {
      this.selectCouponList = list;
      if (list.length === 0) {
        return this.couponFilterCount = 0 
      }
      this.couponFilterCount = this.selectCouponList.map(v => v.priceReduce).reduce((pre, nex) => {
        return pre + nex
      })

    },
    changePod(val) {
      let $selectPlace3 = this.$refs.selectPlace3;
      if($selectPlace3 && $selectPlace3.hideListPopover) $selectPlace3.hideListPopover()
      this.toFABck = val
      if (val.privateAddressType == 1) {
        this.recAddressDTO.recGoodsPostcode = val.namec
      }
      this.getGoodsTypeByCountryId()
      if (!val || (!val.id && val.id !== 0)) {
        this.FBATransmoney.cnyamount = 0
        this.FBATransmoney.amount = 0
        this.FBATransmoney.price = ""
        this.FBATransmoney.currency = ""
        this.FBATransmoney.cnyprice = ""
        this.FBATransmoney.goodsTypeFeeDTOS = []
        this.productFeeList = []
        this.goodsTypeList = []
        // this.ruleformPro.list.forEach((v, index) => {
        //   // this.$set(this.ruleformPro.list[index], 'goodstypeid', '')
        //   this.$set(v, 'goodstypeid', '')
        // })
        return
      }
      this.getFBATrans()
      this.getTimoney()
    },
    enterForAuth() {
      this.$emit('close')
      this.$router.push({
        path:"/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
      });
    },
    getPodList() {
      // /api/FBAfee/selectDestinationByPriceId
      const params = {
        productPriceHeaderId: this.$route.query.productPriceHeaderId
      }
      const isString = this.toFABck.id instanceof String || (typeof this.toFABck.id).toLowerCase() === 'string'
      this.axios
        .get(`/FBAfee/selectDestinationByPriceId?productPriceHeaderId=${this.$route.query.productPriceHeaderId}`, params)
        .then((res) => {
          console.log(this.toFABck.id, isString);
          if (res.data.code == "200") {
            console.log(this)
            this.podList = res.data.datas.map(v => {
              return {
                ...v,
                id: isString ? v.warehouseId : Number(v.warehouseId),
                namec: v.name
              }
            })
            this.setPodData()
          }
        })
    },
    setPodData() {
      let first
      if (isArray(this.podList) && this.podList.length) first = this.podList[0]
      if (first) this.privateAddressType = first.privateAddressType
      this.podTabHead[0].listLevel = 1
      if (this.privateAddressType == 2) {
        // 城市
        this.setLetterGroup()
      } else if (this.privateAddressType == 3) {
        // 邮编首字母
        this.podData = {
          noFba: this.podList
        }
      }
    },
    setLetterGroup() {
      this.podTabHead[0].listLevel = 2
      // this.podLetterGroup
      const letters = []
      const result = []
      this.podList.forEach(v => {
        const firstStr = makePy(v.namec)
        if (!letters.includes(firstStr)) {
          letters.push(firstStr)
        }
      })
      const podLetterGroup = letters.map(v => {
        const list = this.podList.filter(el => makePy(el.namec) === v )
        return {
          code: v,
          list
        }
      })
      this.podData = {
        noFba: podLetterGroup
      }
    },
    excelVisibleBtn () {
      if (!this.toFABck || (!this.toFABck.id && this.toFABck.id !== 0)) {
        return this.$message.warning("请先选择目的地")
      }
      this.excelVisible = true
      this.errorLabel = []
      if (this.fileName) {
        this.elTag = true
        this.excelVisibleSync = false
        this.isReupdateFile = true
      } else {
        this.elTag = false
        this.excelVisibleSync = true
        this.isReupdateFile = false
      }
    },
    // 取消按钮
    excelVisiblefalse () {
      this.excelVisible = false
      this.elTag = true
      this.excelVisibleSync = false
      this.isReupdateFile = true
      this.errorLabel = []
    },
    // 关闭按钮
    handleClose () {
      this.excelVisibleSync = true
      this.elTag = false
      this.fileName = ""
      this.fileUrlList = ""
    },
    //失败时的方法
    handleError (err) {
      this.$message.info(err.data)
    },

    //成功时的方法
    handleSuccess (response) {
      if (response.isSuccess) {
        this.$message.success(response.error)
        // this.getListByParam();
        return
      }
      this.$message.info(response.error)
    },

    // 上传前
    handleBeforeUpload (file) {
      const firstLetter = this.recAddressDTO.recGoodsPostcode.toString().substring(0,1)
      if (this.privateAddressType == 3 && this.toFABck.namec !== firstLetter && this.recAddressDTO.recGoodsPostcode && this.toFABck.namec) {
        this.$message.warning("邮政编码与目的地邮编首位不符")
        return false
      }
      // 校验
      let legalName = ["xls"]
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      )
      if (legalName.includes(name)) {
      } else {
        this.$message.info("文件格式不对，仅限xls")
        return false
      }
    },

    //上传
    uploadSectionFileList (params) {
      let toCountryId = this.$route.query.toCountryid
      const config = {
        onUploadProgress: (progressEvent) => {
          this.progressPercent = Number(
            ((progressEvent.loaded / progressEvent.total) * 90).toFixed(2)
          )
        },
      }
      this.progressFlag = true
      let form = new FormData()
      form.append("file", params.file)
      form.append("toCountryId", toCountryId)
      form.append("productId", this.itemWrap.productId)
      form.append("fromCityId", this.fromCityid)
      form.append("toCountryId", this.itemWrap.countryId)
      form.append("productPriceHeaderId", this.itemWrap.productPriceHeaderId)
      // form.append("toCityId", this.$route.query.toCityId)
      form.append("toCityId", this.toFABck.id.toString())
      form.append("postcode", this.recAddressDTO.recGoodsPostcode)
      this.axios
        .post(`/busFbx/uploadPrivateOrderedAttachment`, form, config)
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.progressPercent = 100
              this.excelVisibleSync = false
              this.elTag = true
              this.isReupdateFile = true
              this.fileName = res.data.data.fileName
              this.errorLabel = []
              // this.fileUrl = res.data.data.fileUrl;
              // this.fileSize = res.data.data.fileSize;
              this.$message.info(res.data.message)
              this.goodsForm.preAllWeight = res.data.data.allWeight
              this.goodsForm.preAllCbm = res.data.data.allCbm
              this.goodsForm.preBoxNum = res.data.data.allBoxNum
              this.privateOrderBoxAttachmentDTO.fileName = res.data.data.fileName
              this.privateOrderBoxAttachmentDTO.fileSize = res.data.data.fileSize
              this.privateOrderBoxAttachmentDTO.fileUrl = res.data.data.fileUrl
              this.formInline.sumWeight = res.data.data.allWeight
              this.formInline.sumCbm = res.data.data.allCbm

              if (
                res.data.data.proInfoDTOS != "" ||
                res.data.data.proInfoDTOS != null
              ) {
                let list = []
                this.ruleformPro.list = [];
                res.data.data.proInfoDTOS.map((item, index) => {
                  const goods = res.data.data.boxUploadDTOS.find(ele => {
                    return ele.goodstype === item.goodsType
                  })
                  list.push({
                    weight: item.weight,
                    boxNum: item.boxNum,
                    goodsType: item.goodsType,
                    goodstypeid: goods.goodstypeid,
                    cbm: item.cbm
                  })
                })
                this.ruleformPro.list.push(...list);
              }
              this.ruleform.formLIst = res.data.data.boxUploadDTOS.map(item => {
                let obj = {
                  ...item,
                  goodsTypeId: item.goodstypeid,
                  goodsType: item.goodstype,
                  isgetgoodstodoor: this.THFdata.checked
                }
                return obj
              })
              if (
                this.ruleform.formLIst.length > 4 &&
                this.ruleform.formLIst.length != 4
              ) {
                let tablelist = this.ruleform.formLIst
                this.tableDataDetail = tablelist.slice(0, 4)
                this.isGetMDate = true
              } else {
                this.isGetMDate = false
                this.tableDataDetail = this.ruleform.formLIst.map(item => {
                  let obj = {
                    ...item,
                    goodsTypeId: item.goodstypeid,
                    goodsType: item.goodstype,
                    isgetgoodstodoor: this.THFdata.checked
                  }
                  return obj
                })
              }
              this.getFBATrans() //重新计算运输费
              this.getTimoney() //重新计算提货费
              this.moreNum = this.ruleform.formLIst.length - 4
              if (this.ischecked == true) {
                this.Changehandle() //获取增值服务费
              }
            }, 500)
            setTimeout(() => {
              this.progressFlag = false
              this.progressPercent = 0
              this.excelVisible = false
            }, 2000)
          } if (res.data.code == -1) {
            setTimeout(() => {
              this.errorLabel = res.data.data
              this.$message.info(res.data.message)
              this.progressFlag = false
              this.progressPercent = 0
            }, 2000)
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },

    // 箱子-点击加载更多
    getMData () {
      this.tableDataDetail = this.ruleform.formLIst
      this.isGetMDate = false
    },

    // 重新上传
    reUpdateFile () {
      this.elTag = false
      this.isReupdateFile = true
      this.excelVisibleSync = true
    },

    // 明细按钮
    packingDetails () {
      this.googDetail = true
    },

    // 关闭商品明细
    handleCloseDetails () {
      this.isDetailList = true
      this.showGoodsList = false
    },

    // 商品明细数据
    getBoxDetail (goodsList, row) {
      this.goodsList = goodsList.map((res) => {
        return Object.assign({}, res)
      })
      this.showGoodsList = true
      // console.log(goodsList);
      if (this.goodsList.length > 4 && this.goodsList.length != 4) {
        let tableList = this.goodsList
        this.goodsDetailList = tableList.slice(0, 4)
      } else {
        this.goodsDetailList = this.goodsList
        this.isDetailList = false
      }
      this.moreNumber = this.goodsList.length - 4
    },

    // 商品-点击加载更多
    DetailListMate () {
      this.goodsDetailList = this.goodsList
      this.isDetailList = false
    },

    number (e) {
      // console.log(this.goodsForm.preBoxNum)
      let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value)
      if (!flag) {
        let num = this.goodsForm.preBoxNum.split(".")[0]
        // console.log("111=",num)
        this.goodsForm.preBoxNum = num
      }
      if (e.target.value - 100000 >= 0) {
        this.goodsForm.preBoxNum = 99999
      }
    },

    inputNum (e) {
      let flag = new RegExp("/(^[1-9]d*(.d{1,3})?$)|(^0(.d{1,3})?$)/").test(
        e.target.value
      )
      if (!flag) {
        let num = e.target.value.match(/\d+(\.\d{0,3})?/)[0]
        this.goodsForm.preAllWeight = num
        let arr = 0
        this.ruleformPro.list.map((item, index) => {
          arr += Number(item.weight)
        })
        this.formInline.sumWeight = arr.toFixed(2)
      }
      if (e.target.value - 100000 >= 0) {
        this.goodsForm.preAllWeight = 99999
      }
    },

    inputNumCbm (e) {
      let flag = new RegExp("/(^[1-9]d*(.d{1,3})?$)|(^0(.d{1,3})?$)/").test(
        e.target.value
      )
      if (!flag) {
        let num = e.target.value.match(/\d+(\.\d{0,3})?/)[0]
        this.goodsForm.preAllCbm = num
        let arr = 0
        this.ruleformPro.list.map((item, index) => {
          arr += Number(item.cbm)
        })
        this.formInline.sumCbm = arr.toFixed(3)
      }
      if (e.target.value - 100000 >= 0) {
        this.goodsForm.preAllCbm = 99999
      }
    },

    closeaddPopmo () {
      this.deliverShow = false
    },
    showdeliver () {
      this.deliverShow = true
      this.countListName = false
      this.countLisTtel = false
    },

    closeDeliver () {
      this.deliverShow = false
    },
    setDeliver (item) {
      this.countLIst_S = item
    },

    handleSelectionChange (val) {
      this.thatGoodslist = val
      // console.log(val);
    },
    isSize (val) {
      val = val.replace(/[^0-9]/gi, "")
      return val
    },
    isnumber (val) {
      val = val.replace(/\d+(\.\d{0,2})?/, "")
      return val
    },

    changeTi () {
      this.THFdata.checked != this.THFdata.checked
      if (this.THFdata.checked) {
        this.storeHouseFlag = false
        //取消提货费
      } else {
        this.storeHouseFlag = true
        // this.messageFlag = false
      }
      this.getTimoney()
      this.getFBATrans()
    },
    closeExtractlog (Titem) {
      if (!Titem) {
        // 第一次点击但是不选择 直接关闭
        let countLIst = JSON.parse(sessionStorage.getItem("countLIst_T"))
        if (!countLIst) {
          this.pickUparess = ""
        } else {
          // 已有值 但是不选择
          this.countLIst_T.parvince = countLIst.parvince
          this.countLIst_T.city = countLIst.city
          this.countLIst_T.area = countLIst.area
          this.countLIst_T.address = countLIst.address
          this.pickUparess =
            this.countLIst_T.parvince +
            this.countLIst_T.city +
            this.countLIst_T.area +
            this.countLIst_T.address
        }
      } else {
        // console.log("1111",Titem)
        this.MessParvince = Titem.parvince
        this.MessCity = Titem.city
        if (Titem.cityId != this.fromCityid) {
          this.messageFlag = true
        }
        // this.fromCityid = Titem.cityId
        this.countLIst_T = Titem
        this.pickUparess =
          this.countLIst_T.parvince +
          this.countLIst_T.city +
          this.countLIst_T.area +
          this.countLIst_T.address

        // 提货费提示
        const flag = this.itemWrap.cityList.some(item => {
          return item.id == Titem.cityId
        })
        console.log(flag, 111)
        this.THFTipsFlag = !flag
        this.getFBATrans()
      }

      this.showMydialog = false
    },
    //获取提货费
    getTimoney () {
      // let that = this
      // let params = {
      //   province: this.countLIst_T.parvince, //省 name
      //   city: this.countLIst_T.city, //市 name
      //   area: this.countLIst_T.area, //区 name
      //   customerId: this.sessionGetUserInfo()
      //     .customerid, //客户id
      //   feeCode: "THF",
      //   weight: this.goodsForm.preAllWeight,
      //   cbm: this.goodsForm.preAllCbm,
      //   cityId: this.fromCityid,
      // }
      // this.axios
      //   .post(`/FBAfee/getFBAPickUpFee`, params)
      //   .then((res) => {
      //     // console.log(res.data.data);
      //     if (res.data.code == "200") {
      //       if (res.data.data) {
      //         that.THFdata.price = res.data.data.price //价格
      //         that.THFdata.currency = res.data.data.currency //币种
      //         that.THFdata.cnyprice = res.data.data.cnyprice //--隐藏单价
      //         that.THFdata.cnycurrency = res.data.data.cnycurrency //”CNY”--换算币种
      //         that.THFdata.cnyamount = res.data.data.cnyprice //”CNY”--换算币种
      //         that.THFdata.amount = res.data.data.price
      //         that.THFdata.maxKilometer = res.data.data.maxKilometer
      //         that.THFdata.minKilometer = res.data.data.minKilometer
      //         that.THFdata.calDesc = res.data.data.calDesc
      //       } else {
      //         that.THFdata.price = null
      //         that.THFdata.currency = ""
      //         that.THFdata.cnyprice = null
      //         that.THFdata.amount = null
      //       }
      //     } else {
      //     }
      //   })
      //   .catch((res) => { })
    },

    //获取运输费
    getFBATrans () {
      if (!this.toFABck || (!this.toFABck.id && this.toFABck.id !== 0)) return this.errormessage = '请先选择目的地'
      else this.errormessage = ''
      this.loadin = true
      let that = this
      const firstLetter = this.recAddressDTO.recGoodsPostcode.toString().substring(0,1)
      if (this.privateAddressType == 3 && this.toFABck.namec !== firstLetter && this.recAddressDTO.recGoodsPostcode && this.toFABck.namec) {
        return false
      }
      let params = {
        customerId: this.sessionGetUserInfo().customerid, //客户id
        productPriceHeaderId: this.$route.query.productPriceHeaderId,
        // allCbm: this.goodsForm.preAllCbm,
        // allWeight: this.goodsForm.preAllWeight,
        allCbm: this.formInline.sumCbm,
        allWeight: this.formInline.sumWeight,
        boxNum: this.getNumBox,
        postcode: this.recAddressDTO.recGoodsPostcode,
        fromCityId: this.fromCityid,
        isgetgoodstodoor: this.THFdata.checked,
        // boxDTOS: this.ruleform.formLIst[0].length ? this.ruleform.formLIst : [],
        boxDTOS: this.ruleform.formLIst[0].length ?
          this.ruleform.formLIst :
          this.ruleformPro.list.map(item => {
            return {
              ...item,
              goodsTypeId: item.goodstypeid,
              goodsDTOList: [],
              height: 1,
              width: 1,
              length: 1
            }
          }),
        // toCityId: this.$route.query.toCityId, // 非FBA仓库城市id或邮编
        toCityId: this.toFABck.id.toString(), // 非FBA仓库城市id或邮编
        countryId: this.$route.query.toCountryid,
        isSelfDelivery: this.isSelfDelivery
      }
      if (this.$route.query.supplierId) {
        params.supplierId = this.$route.query.supplierId
      }
      const fromCityid = sessionStorage.getItem("fromCityid") || this.fromCityid
      if (this.countLIst_T && this.countLIst_T.cityId == fromCityid && this.itemWrap.domDTO) {
        params.transPriceDomId = this.itemWrap.domDTO ? this.itemWrap.domDTO.id : ''
      }
      
      this.axios
        .post(`/FBAfee/calPrivateAddrTransportFee`, params)
        .then((res) => {
          // console.log("运输费", res);
          if (res.data.code == "200") {
            if (res.data.data) {
              that.FBATransmoney.price = res.data.data.price
              that.FBATransmoney.currency = res.data.data.currency
              that.FBATransmoney.cnyprice = res.data.data.price
              that.FBATransmoney.piece = 1
              that.FBATransmoney.amount = res.data.data.amount
              that.FBATransmoney.cnyamount = res.data.data.cnyamount
              that.FBATransmoney.goodsTypeFeeDTOS = res.data.data.goodsTypeFeeDTOS
              that.FBATransmoney.chargeWeight = res.data.data.chargeWeight
              this.errormessage = ''

              // res.data.data.surchargeDTOS = [
              //   {
              //     productTypeName: '织物',
              //     calRemark: 'CNY 80=40KG*2',
              //     currency: 'CNY',
              //     totalPrice: '80'
              //   },
              //   {
              //     productTypeName: '织物',
              //     calRemark: 'CNY 80=40KG*2',
              //     currency: 'CNY',
              //     totalPrice: '80'
              //   }
              // ]
              that.FBATransmoney.surchargeDTOS = res.data.data.surchargeDTOS
              this.getCouponListData()
              let productList = res.data.data.surchargeDTOS;
              let feeList = [];
              productList.map((item, index) => {
                feeList.push({
                  label: `产品附加费(${item.productTypeName})`,
                  // chargeInfo: `${item.currency} ${item.totalPrice}=${item.chargeWeight}${item.}*${item.price}`,
                  changeInfo: item.calRemark,
                  value: item.currency + item.totalPrice,
                });
              });

              this.productFeeList = feeList;
            } else {
              that.FBATransmoney.cnyamount = 0
              that.FBATransmoney.amount = 0
              that.FBATransmoney.price = ""
              that.FBATransmoney.currency = ""
              that.FBATransmoney.cnyprice = ""
              that.FBATransmoney.goodsTypeFeeDTOS = []
            }
          } else {
            that.FBATransmoney.cnyamount = 0
            that.FBATransmoney.amount = 0
            that.FBATransmoney.price = ""
            that.FBATransmoney.currency = ""
            that.FBATransmoney.cnyprice = ""
            that.FBATransmoney.goodsTypeFeeDTOS = []
            this.errormessage = res.data.message
          }
        })
        .catch((res) => { })
    },

    // 获取增值服务费
    Changehandle () {
      // console.log("ischecked==",this.ischecked)
      if (this.ischecked == true) {
        let that = this
        let busFbxjobsBeforeBoxDTOList = []
        busFbxjobsBeforeBoxDTOList = this.ruleform.formLIst
        let countryId = this.$route.query.toCountryid //国家id
        let params = {
          busFbxjobsBeforeBoxDTOList,
          countryId,
        }
        this.axios
          .post(`/FBAfee/calDeclareFee`, params)
          .then((res) => {
            if (res.data.code == "200") {
              let Newarray = res.data.data.feeItemDTOList
              that.calFBAFeeIDTOS.feeDTOList = res.data.data.feeItemDTOList
              that.calFBAFeeIDTOS.amount = res.data.data.amount
              this.formData.feeItemDTOList.forEach((item, index) => {
                if (Newarray[index].feeCode == item.feeCode) {
                  item.amount = Newarray[index].amount
                  item.calDesc = Newarray[index].calDesc
                }
              })
            } else {
            }
          })
          .catch((res) => { })
      } else {
        this.calFBAFeeIDTOS.feeDTOList = [{ amount: 0, feeName: "" }]
        this.calFBAFeeIDTOS.amount = 0
      }
    },
    ChangehandleDeclare () {
      this.calFBAFeeIDTOS.feeDTOList = [{ amount: 0, feeName: "" }]
      this.calFBAFeeIDTOS.amount = 0
    },
    submitForm () {
      if (!this.toFABck || !this.toFABck.id && this.toFABck.id !== 0) return this.errormessage = '请先选择目的地'
      else this.errormessage = ''
      if (!this.checkvalue) return this.$message({ message: '请勾选《货物承运电子协议》', type: "error" })
      let File = false
      try {
        this.$refs["fromText"].validate((valid) => {
          if (valid) {
            File = true
          } else {
            throw false
          }
        })
        this.$refs["rulegoodsForm"].validate((valid) => {
          if (valid) {
            File = true
          } else {
            throw false
          }
        })
      } catch (err) {
        File = false
      }
      if (File) {
        sendCustomerOperationRecord("提交订单",`产品名称:${this.itemWrap.productName}`);
        this.onToNext()
      }
    },
    //提交订单
    onToNext () {
      if (this.THFdata.checked == true) {
        if (
          this.countLIst_T.parvince == "" ||
          this.countLIst_T.parvince == null
        ) {
          this.countlistAddress = true
          return
        } else {
          this.countlistAddress = false
        }

        if (this.todoorTime == "" || this.todoorTime == null) {
          this.thfPicker = true
          return
        } else {
          this.thfPicker = false
        }
        // if (this.countLIst_S.name == "" || this.countLIst_S.name == null) {
        //   this.countListName = true;
        //   return;
        // } else {
        //   this.countListName = false;
        // }
        // if (this.countLIst_S.tel == "" || this.countLIst_S.tel == null) {
        //   this.countLisTtel = true;
        //   return;
        // } else {
        //   this.countLisTtel = false;
        // }
      } else {
        if (this.inwarehousetime == "" || this.inwarehousetime == null) {
          this.houseTime = true
          return
        } else {
          this.houseTime = false
        }

        if (this.countLIst_S.name == "" || this.countLIst_S.name == null) {
          this.countListName = true
          return
        } else {
          this.countListName = false
        }

        if (this.countLIst_S.tel == "" || this.countLIst_S.tel == null) {
          this.countListName = true
          return
        } else {
          this.countListName = false
        }
      }
      // if (this.ruleform.formLIst) {
      //   if (this.ruleform.formLIst[0].goodsDTOList.length <= 0) {
      //     this.ruleform.formLIst = null
      //   }
      // }

      // console.log("formLIst==",this.ruleform.formLIst)

      let filesList = []
      if (this.uploadData.fileList) {
        filesList = this.uploadData.fileList.map((item) => ({
          contentType: item.contentType,
          fileName: item.name,
          filePath: item.url,
          fileSize: item.fileSize,
        }))
      }

      // 没有装箱单的情况
      let boxProInfoDTOS = []
      if (!this.ruleform.formLIst[0].length) {
        boxProInfoDTOS = this.ruleform.formLIst[0].length ?
          this.ruleform.formLIst :
          this.ruleformPro.list.map(item => {
            return {
              ...item,
              goodstype: item.goodsType,
              goodsDTOList: [],
              height: 1,
              width: 1,
              length: 1,
              fbxBoxNo: 1
            }
          })
      }
      const loading = this.$loading({
        lock: true,
        text: "下单中请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let params = {
        busFbxjobsBeforeBoxDTOList: this.ruleform.formLIst[0].length ? this.ruleform.formLIst : boxProInfoDTOS,
        countryId: this.$route.query.toCountryid,
        customerOrderNo: this.ruleformAdd.fbxBoxNum,
        customerOrderNosRemark: this.ruleformAdd.FBAremarks,
        customerid: this.sessionGetUserInfo().customerid,
        delgoodsname: this.countLIst_S ? this.countLIst_S.name : "",
        delgoodstel: this.countLIst_S ? this.countLIst_S.tel : "",
        deliveryFbxAddressDTO: {
          getgoodsaddress: this.countLIst_T ? this.countLIst_T.address : "",
          getgoodsarea: this.countLIst_T ? this.countLIst_T.area : "",
          getgoodscity: this.countLIst_T ? this.countLIst_T.city : "",
          getgoodsname: this.countLIst_T ? this.countLIst_T.name : "",
          getgoodsprovince: this.countLIst_T ? this.countLIst_T.parvince : "",
          getgoodstel: this.countLIst_T ? this.countLIst_T.tel : "",
          getremarks: this.getgoodsremarks, //提货备注
        },
        delremarks: "",
        fromCityId: this.fromCityid,
        inwarehouseTime: this.inwarehousetime,
        isDeclare: this.ischecked,
        isgetgoodstodoor: this.THFdata.checked,
        orderAttachmentDTOS: filesList,
        orderId: "",
        preAllCbm: this.goodsForm.preAllCbm,
        preAllWeight: this.goodsForm.preAllWeight,
        // preBoxNum: this.goodsForm.preBoxNum,
        privateOrderBoxAttachmentDTO: this.privateOrderBoxAttachmentDTO,
        productPriceHeaderId: this.$route.query.productPriceHeaderId,
        recAddressDTO: this.recAddressDTO,
        remarks: "",
        source: "WEB",
        todoordate: this.todoorTime,
        transportTypeCode: sessionStorage.getItem("transportTypeCode") || '',
        cnyAmount: this.calculatePrice,
        // toCityId: this.$route.query.toCityId, // 非FBA仓库城市id或邮编
        toCityId: this.toFABck.id.toString(), // 非FBA仓库城市id或邮编
        // productCityId: this.itemWrap.fromCityId,
        productCityId: this.fromCityid,
        isSelfDelivery: this.isSelfDelivery,
        preAllCbm: this.formInline.sumCbm,
        preAllWeight: this.formInline.sumWeight,
        preBoxNum: this.getNumBox,
        // couponId: this.selectCouponList.map(v => v.couponId)
        couponList: this.selectCouponList.map(v => {
          return {
            id: v.couponId,
            price: v.priceReduce
          }
        })
      }
      if (this.$route.query.supplierId) {
        params.supplierId = this.$route.query.supplierId
      }
      const fromCityid = sessionStorage.getItem("fromCityid") || this.fromCityid
      if (this.countLIst_T && this.countLIst_T.cityId == fromCityid && this.itemWrap.domDTO) {
        params.transPriceDomId = this.itemWrap.domDTO ? this.itemWrap.domDTO.id : ''
      }

      this.axios
        .post(`/privateAddr/createPrivateAddressOrder`, params)
        .then((res) => {
          console.log("成功: ", res)
          if (res.data.code == "200") {
            loading.close()
            sessionStorage.setItem("toFABck", JSON.stringify(this.toFABck))
            this.$router.push({
              name: "FbaorderSuccess",
              query: {
                state: 1,
                innos: res.data.data.innos,
                nos: res.data.data.innos,
                isFastOrder: false,
                isUploadAttachment: res.data.data.isUploadAttachment,
                orderNo: res.data.data.innos,
                id: res.data.data.id,
                recAddressDTO: JSON.stringify(res.data.data.recAddressDTO),
              },
            })
          } else {
            loading.close()
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            })
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },
    removefileList (file, fileList) {
      //删除
      console.log("fileList: ", fileList)
      this.uploadData.fileList = fileList
    },
    uploadSectionFile (param) {
      console.log("param: ", param.file)
      let form = new FormData()
      form.append("file", param.file)
      this.axios
        .post(`/busFbx/uploadOrderAttachment`, form)
        .then((res) => {
          console.log(res)
          if (res.data.data) {
            let successData = {
              url: res.data.data.filePath,
              name: res.data.data.fileName,
              contentType: res.data.data.contentType,
              fileSize: res.data.data.fileSize,
            }
            this.uploadData.fileList.push(successData)
            this.$message({
              message: "上传成功",
              type: "success",
            })
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            })
          }
        })
        .catch((res) => {
          console.log(res)
        })
    },
    onScroll () {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop
      // 计算A区的高度
      let header_height = null
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height =
          document.getElementsByClassName("wrap_R")[0].offsetHeight
      }
      if (scrolled >= 200) {
        this.auto_fixed = true
      } else {
        this.auto_fixed = false
      }
    },
    // 显示弹窗
    changeCheic (type) {
      this.showMydialog = true
      this.showMydialog = true
      this.countlistAddress = false
    },
    //下载模板
    Getdown () {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          if (res.status) {
            let a = document.createElement("a")
            let blob = new Blob([res.data])
            let objectUrl = URL.createObjectURL(blob)
            a.setAttribute("href", objectUrl)
            a.setAttribute("download", "货代拼装箱单发票导入模板V2.0.xls")
            a.click()
            URL.revokeObjectURL(objectUrl) // 释放内存
          } else {
          }
        })
        .catch((res) => { })
    },
    getGoodsTypeByCountryId(id) {
      // this.axios
      //   .get(`/fbxData/getGoodsTypeByPrice?countryId=${id}`)
      //   .then((res) => {
      //     let list = res.data.datas;
      //     list.shift()
      //     this.goodsTypeList = list
      //   })
      //   .catch((res) => {});

      this.ruleformPro.list.forEach((v, index) => {
        this.$set(v, 'goodstypeid', '')
      })
      if (!this.toFABck.id && this.toFABck.id !== 0) return
      const data = {
        fromCityId: this.fromCityid,
        podlandId: this.toFABck.id.toString(),
        productPriceHeaderId: this.$route.query.productPriceHeaderId
      }
      this.axios
        // .get(`/fbxData/getGoodsTypeByPrice?countryId=${id}`)
        .post(`/fbxData/getGoodsTypeByPrice`, data)
        .then((res) => {
          let list = res.data.datas
          this.goodsTypeList = list
        })
        .catch((res) => {});
    },
    handleDel (index) {
      this.ruleformPro.list.splice(index, 1)
    },
    handleAdd (index) {
      this.ruleformPro.list.push({
        weight: "",
        cbm: "",
        boxNum: "",
        goodstypeid: ""
      })
    },
    // 验证小数
    validataCode (val) {
      this.$refs.refFormInline.validateField("sumWeight")
    },
    validataCodeCmb (val) {
      this.$refs.refFormInline.validateField("sunCmb")
    },
    setGoodType(val, index) {
      const good = this.goodsTypeList.find(item => {
        return val === item.goodsTypeId
      })
      this.ruleformPro.list[index].goodsType = good.goodsTypeName
    },
    async checkAuth() {
      // /api/user/getUserLoginInfo/1
      const result = await this.axios.get(`/user/getUserLoginInfo/1`).catch((res) => {})
      // console.log('message', result)
      if (result) {
        this.$store.commit("addUserdata", result.data.data)
        if (!this.Authorization.authenticationInfoDTO || this.Authorization.authenticationInfoDTO.state !== 3 ) {
          console.log('未实名')
          this.checkVisible = true
        } else if (this.Authorization.authenticationInfoDTO.type === 2 || this.Authorization.authenticationInfoDTO.type === 3) {
					// 分销大使、省代
					this.checkVisible = true
				}
      } else {
        this.$message.warning('获取当前用户最新信息失败')
      }
    },
/**
     * 显示 邮编分区 搜索弹窗
     * @param type  {string}  all-全包 head-头程 delivery-派送
     * @param name  {string}  名称/邮编分区名称
     */
    async showZipCodeSearch(type,name){
      let idItem = this.toFABck;
      if(!idItem || !idItem.id) return this.$message.error(`邮编分区id为空`);

      this.getZipCodeRegionList(idItem.id)
        .then(res=>{
          this.visibleZipCode = true;
        })
        .catch(res=>{
          this.$message.error(`获取邮编分区数据：${res.message||"网络异常"}`);
        })
      // console.log(result);
      this.visibleZipCode = true;
    },
    hideZipCodeSearch(){
      this.visibleZipCode = false;
    },
    /**
     * 请求邮编分区数据
     */
    getZipCodeRegionList(zipCodeRegionId){
      const data = {
        id:zipCodeRegionId||"",
        "countryId": "",//所属国家id
        "regionId": "",//邮编分区id
        "partitionSchemeName": "",//分区方案名称
      };
      const url = "/api/zipZone/list";
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let list = res.datas||[];
          this.zipCodeRegionList = list;
          return res
        })
        .catch(res=>{
          this.zipCodeRegionList = [];
          return Promise.reject(res);
        })
    },
    setDefaultAddressData() {
      let that = this
      let customerId = this.sessionGetUserInfo().customerid
      // if (this.THFdata.checked) {
        this.axios
        .get(`/customer/addressListForFBADelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            const tableData = res.data.datas
            const result = tableData.find(v => {
              return v.isdefault
            })
            const withCity = this.cityWhiteList.map(v => v.id)
            if (!withCity.includes(result.cityId)) return false // 默认地址与关联提货城市不匹配
            if (result) {
              this.countLIst_T = result
              this.pickUparess =
              this.countLIst_T.parvince +
              this.countLIst_T.city +
              this.countLIst_T.area +
              this.countLIst_T.address
              this.THFTipsFlag = true

              this.MessParvince = result.parvince
              this.MessCity = result.city
              if (result.cityId != this.fromCityid) {
                this.messageFlag = true
              }
            }
          } else {
          }
        })
        .catch((res) => { })
      // } else {
        this.axios
          .get(`/customer/addressListForShipper/${customerId}`)
          .then((res) => {
            if (res.data.code == "200") {
              const FapopList = res.data.datas
              const result = FapopList.find(v => {
                return v.isdefault
              })
              if (result) {
                this.countLIst_S = result
                this.THFTipsFlag = true
              }
            } else {
            }
          })
          .catch((res) => {
            console.log(res)
          })
      // }
    },
    async getcanCheckCities() {
      const cities = this.itemWrap.cityList.map(v => v.id)
      const fromCityid = sessionStorage.getItem("fromCityid") || this.fromCityid
      if (!cities.includes(Number(fromCityid))) cities.push(Number(fromCityid))
      const data = {
        ids: cities
      }
      const result = await this.axios.post(`/api/corporation/pickUpCiti`, data).catch()
      if (result) {
        console.log('------')
        if (result.data.code === 200) {
          this.cityWhiteList = result.data.datas
        }
      }
    }
  },
  created () {
    this.checkAuth()
    if (this.itemWrap.deliveryType === 'ZT') this.isSelfDelivery = true  // 派送方式为自提时默认自提且不可修改
    this.transportTypeCode = sessionStorage.getItem("transportTypeCode") || ''
    if (this.itemWrap.domDTO) this.fromCityid = this.itemWrap.domDTO ? this.itemWrap.domDTO.endCityId : ''
    this.getGoodsTypeByCountryId(this.$route.query.toCountryid)
    this.getPodList()
    this.getcanCheckCities().then(res => {
      this.setDefaultAddressData()
    })
    // this.setDefaultAddressData()
  },
  mounted () {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll)
    })
    // if (this.itemWrap.selfDelivery === 2) {
    //   this.isSelfDelivery = false
    // } else if (this.itemWrap.selfDelivery === 3) {
    //   this.isSelfDelivery = true
    // }
  },
};
</script>
<style scoped lang="less">
.upload-demo {
  /deep/ .el-upload-list {
  }
  /deep/ .el-upload-list__item-name {
    text-align: left;
    padding-left: 0;
  }
}
</style>
<style scoped>
/deep/ .search-text {
  font-size: 14px !important;
}
/deep/ .value-text .text-row {
  font-size: 14px !important;
}
.select-place-template {
  border-radius: 5px!important;
  border: 1px solid #DCDFE6;
  background: transparent !important;
}
.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
}

/* 删除 */
.deleteBox {
  position: absolute;
  color: #FF4D01;
  top: -4px;
  /* align-items: center; */
  /* text-align: center; */
  /* margin-top: 4px; */
}

.num-box {
  width: 100%;
  box-sizing: border-box;
  margin: 15px 0;
}

.numBox {
  padding: 20px 40px 0 40px;
  box-sizing: border-box;
  text-align: center;
}

.cmb-box {
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  align-items: center;
  z-index: 1;
}

/* .tipRem {
  width: 100%;
  color: #FF4D01;
  box-sizing: border-box;
  float: left;
  padding: 0 20px 20px 60px;
} */

.box-card {
  position: relative;
}

.card_header {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
}
.card_count {
  padding: 20px 20px 0 20px;
}
.addStyle {
  padding: 10px 0;
  box-sizing: border-box;
}
.header_logo {
  height: 30px;
  line-height: 30px;
  margin-left: 4px;
  color: #fff;
  position: absolute;
  top: 11px;
  right: 0px;
  border-radius: 20px 0px 0px 20px;
  background: #FF4D01;
  font-weight: bold;
  border-style: none none solid solid;
  /* border-color: #83a4fe;
  border-width: 3px; */
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.boxindex {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #FF4D01;
  text-align: center;
  top: 10px;
  left: -17px;
  color: #ffffff;
  line-height: 25px;
  font-size: 18px;
  text-align: center;
}
.cloneType {
  color: #ffffff;
  float: left;
}

.deleteBtn {
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 15px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.goodsTextFlex {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.fontString {
  font-weight: bold;
  float: right;
}
.auto_fixed {
  position: fixed;
  top: 0px;
  margin-left: 920px;
}
.goodsValue >>> .el-input__inner {
  border-radius: 0 !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
  border: none;
  border-bottom: 1px solid #9999;
}
/deep/ .el-input__inner {
  height: 30px !important;
}
/* 去除 number类型 的自带默认箭头 */
.handNumber >>> .el-input__inner::-webkit-outer-spin-button,
.handNumber >>> .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.handNumber >>> .el-input__inner[type='number'] {
  -moz-appearance: textfield;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.card_header >>> .el-form-item {
  margin-bottom: 0px !important;
}
.upload-demo >>> .el-upload-dragger {
  width: 265px !important;
}

.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999;
}
.goodLi {
  width: 100%;
  height: 30px;
  padding: 0px;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.center_wrap {
  padding-top: 30px;
  width: 1200px;
  margin: 0 auto;
}
.semillWrap >>> .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  width: 100% !important;
  margin-bottom: 22px;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 0px 15px 15px 40px;
  box-sizing: border-box;
}

.wrap_l {
  float: left;
  width: 900px;
  background: #f5f5f5;
  /* padding: 0 35px; */
  box-sizing: border-box;
}
.leftItem {
  width: 100%;
  /* float: left; */
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 30px;
  margin-bottom: 20px;
  overflow: hidden;
}
.wrap_R {
  float: right;
  width: 280px;
  max-height: 95vh;
  overflow: auto;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 30px;
  padding: 18px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}

.count {
  width: 100%;
  padding-top: 30px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.Shipment {
  position: absolute;
  top: 20px;
}

.ShipmentID {
  position: absolute;
  top: 66px;
}

.googDetailBox {
  margin-top: 20px;
  width: 100%;
  height: 30px;
  border-top: 1px #8c939d dashed;
  font-size: 20px;
}

.KnowBox {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.TextCenter >>> .el-form-item__label {
  text-align: right;
}
.marginzero >>> .el-form-item {
  margin-bottom: 10px;
}

.costBox {
  /* float: left; */
  position: relative;
  width: 100%;
  margin-top: 4px;
  box-sizing: border-box !important;
}
.detailed {
  /* width: 30%; */
  display: inline-block;
  word-break: break-all;
  vertical-align: middle
}

.descbox {
  /* position: absolute;
  right: 0px; */
  /* position: relative; */
  margin-left: 4px;
  text-align: right;
  right: 0px;
  width: calc(70% - 8px);
  vertical-align: middle;
}

.fontStyle {
  font-size: 8px;
  /* margin-top: -6px; */
  color: #FF4D01;
  position: absolute;
  bottom: -24px;
  left: 0;
}
.packingbox {
  position: absolute;
  left: 700px;
  top: 4px;
}

.DetailsBox {
  position: absolute;
  left: -120px;
  margin-top: 6px;
}

.tagBox {
  max-width: 300px;
  display: inline-block;
  height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  line-height: 32px;
  /* width:120px; */
}

/deep/ .el-collapse-item__header {
  height: 65px;
}

.tipRem {
  width: 790px;
  height: 40px;
  padding: 8px 18px;
  background-color: #fff6e6;
  color: #ffbf4d;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 20px 0;
  font-size: 14px;
}

.messageTag {
  display: inline-block;
  width: 100%;
  background-color: #fff6e6;
  color: #ffbf4d;
  border-radius: 5px;
  padding: 12px 18px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.info_list {
  padding: 12px 0 6px 24px;
  line-height: 30px;
}

.el-form--label-left >>> .el-form-item__label {
  color: #999999 !important;
}

.el-form--inline .el-form-item__label {
  color: #999999 !important;
}

/deep/ .el-collapse-item__arrow {
  margin: 0 30px 0 auto !important;
  font-weight: 700 !important;
  font-size: 20px !important;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #333 !important;
}

.el-button .el-button--default .el-button--small {
  margin-top: -3px;
  width: 68px;
  height: 30px;
}
</style>
<style lang="scss">
.open-by-check{
  .el-dialog {
    border-radius: 20px;
  }
  font-family: Source Han Sans CN;
  .el-dialog__header{
    text-align: center;
    padding: 16px 32px;
  }
  .header-row .title,
  .el-dialog__title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    position: relative;
  }
  .el-dialog__headerbtn{

  }
  .header-row{
    display: flex;
    text-align: center;
    .close{
      cursor: pointer;
      position: absolute;
      z-index: 2;
      right: 17px;
      top: 16px;
      font-size: 24px;
      color: #727272;
      &:hover{
        color: #FF4D01;
      }
    }
  }

  .el-dialog__body{
    padding: 0 32px 20px;
  }
  .hint{
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    line-height: 28px;
  }
  .step-row{
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    line-height: 30px;
  }
  .footer-row{
    margin: 20px auto;
    display: flex;
    justify-content: space-around;
  }
  .btn-cancel,
  .btn-confirm{
    margin: 0;
    width: 130px;
    border-radius: 10px;
    height: 50px;
    border-width: 2px;
    font-weight: bold;
    font-size: 18px;
  }
  .btn-cancel:not(:hover){
    background-color: white;
    border-color: #FF4D01;
    color: #FF4D01;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/privateOrder/privateBill.vue